<template>
    <div class="warning window incident-notice" v-if="VUE_APP_BLOCKCHAIN_ID === 'harmony'">
        Harmony announcement: <a
            href="https://recoveryonefoundation.medium.com/recovering-depegged-assets-from-curve-finance-pools-on-harmony-0184fc83936f"
            target="_blank" rel="noopener noreferrer">Recovering Depegged Assets from Curve Finance Pools on Harmony</a>
    </div>
</template>

<script>
export default {
    data: () => ({
        VUE_APP_BLOCKCHAIN_ID: process.env.VUE_APP_BLOCKCHAIN_ID,
    }),
}
</script>

<style scoped>
.incident-notice {
    font-style: italic;
}
</style>
